import React from "react";
import PaymentMethodButton from "./PaymentMethodButton";
import OrderPreferencesButton from "./OrderPreferencesButton";
import TariffSelector from "./TariffSelector";
import { useUIActions } from "../store/useActions";

const OrderDetailsMenu = () => {
  const { setNavbarPreferencesOpened } = useUIActions();

  return (
    <div className="order-details-wrapper" style={{ flexDirection: "column", gap: "4px" }}>
      <TariffSelector />
      <div style={{ display: "flex", gap: "8px", width: "100%" }}>
        <PaymentMethodButton />
        <OrderPreferencesButton
          onClick={() => setNavbarPreferencesOpened(true)}
          margin={"0 0 0 1em"}
        />
      </div>
    </div>
  );
};

export default OrderDetailsMenu;
